import DefaultGrid from './Components/DefaultGrid.vue'
import DataStatusDisplay from './Components/DataStatusDisplay.vue'
import DataSortFilter from './Components/DataSortFilter.vue'
import CsvImportExport from './Components/CsvImportExport.vue'
import CellReadonly from './Components/CellReadonly.vue'
import ColumnToggle from './Components/ColumnToggle.vue'
import CellDefaultComponent from './Components/CellDefaultComponent.vue'
import DataAddRemoveBtn from './Components/DataAddRemoveBtn.vue'
import DataDragDrop from './Components/DataDragDrop.vue'
import ColumnHeaderGroup from './Components/ColumnHeaderGroup.vue'
import ColumnPinned from './Components/ColumnPinned.vue'
import PaginationClient from './Components/PaginationClient.vue'
import PaginationServer from './Components/PaginationServer.vue'

export default {
  components: {
    DefaultGrid,
    DataStatusDisplay,
    DataSortFilter,
    CsvImportExport,
    CellReadonly,
    ColumnToggle,
    CellDefaultComponent,
    DataAddRemoveBtn,
    DataDragDrop,
    ColumnHeaderGroup,
    ColumnPinned,
    PaginationClient,
    PaginationServer
  },
  created () {
  },
  methods: {
  },
  data: function () {
    return {
      activeTab: 0
    }
  }
}
